<template>
    <div class="modal-overlay" v-if="visible" @click="handleOverlayClick">
        <div class="modal-content" @click.stop>
            <div class="modal-header">
                <h3 class="modal-title">{{ data.title }}</h3>
                <button class="modal-close" @click="close"></button>
            </div>
            <div class="modal-body">
                <!-- 第一行：视频播放和证据列表 -->
                <div class="modal-row">
                    <!-- 左侧：视频播放和问题描述 -->
                    <div class="modal-left ">
                        <div class="video-section modal-card">
                            <h4 class="section-title video-title">视频播放</h4>
                            <video class="modal-video" controls>
                                <source :src="data.videoSrc" type="video/mp4">
                                您的浏览器不支持视频播放
                            </video>
                        </div>
                        <div class="problem-description modal-card">
                            <h4 class="section-title problem-title">存在问题描述</h4>
                            <p>{{ data.problemDescription }}</p>
                        </div>
                    </div>

                    <!-- 右侧：证据列表表格 -->
                    <div class="modal-right modal-card">
                        <div class="evidence-section">
                            <h4 class="section-title evidence-title">证据列表</h4>
                            <div class="evidence-table-container">
                                <el-table :data="data.evidenceList" style="width: 100%; height: 100%" :border="false" height="100%"
                                    :header-cell-style="{ background: 'rgba(5, 133, 247, 0.2)', color: '#9ED1FF', fontWeight: '500' }"
                                    class="custom-scrollbar-table"
                                     ref="evidenceTable">
                                    <el-table-column prop="id" label="证据编号" width="120"></el-table-column>
                                    <el-table-column prop="type" label="证据类型" width="120"></el-table-column>
                                    <el-table-column prop="time" label="时间"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 第二行：折线图 -->
                <div class="modal-row chart-row modal-card">
                    <div class="chart-section">
                        <h4 class="section-title chart-title">三级维度名称</h4>
                        <div ref="chartContainer" class="chart-content" style="height: 170px;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({
                title: '详细信息',
                videoSrc: '',
                problemDescription: '这里显示存在的问题描述信息，详细说明当前检测到的异常情况或需要关注的内容。',
                evidenceList: [],
                chartPlaceholder: '折线图区域'
            })
        }
    },
    data() {
        return {
            chartInstance: null
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.initChart();
                    this.customizeTableScrollbars();
                });
            } else {
                this.disposeChart();
            }
        }
    },
    methods: {
        close() {
            this.$emit('update:visible', false);
            this.$emit('close');
        },
        handleOverlayClick() {
            this.close();
        },
        initChart() {
            if (!this.$refs.chartContainer) return;
            
            // 动态引入echarts
            import('echarts').then(echarts => {
                const chart = echarts.init(this.$refs.chartContainer);
                
                const option = {
                    backgroundColor: 'transparent',
                    grid: {
                        top: '15%',
                        left: '3%',
                        right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月', '6月'],
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(158, 209, 255, 0.5)'
                            }
                        },
                        axisLabel: {
                            color: '#9ED1FF',
                            fontSize: 12
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(158, 209, 255, 0.5)'
                            }
                        },
                        axisLabel: {
                            color: '#9ED1FF',
                            fontSize: 12
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(158, 209, 255, 0.1)'
                            }
                        }
                    },
                    series: [{
                        data: [120, 200, 150, 80, 70, 110],
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            color: '#00FFC6',
                            width: 2
                        },
                        itemStyle: {
                            color: '#00FFC6',
                            borderColor: '#00FFC6',
                            borderWidth: 2
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(0, 255, 198, 0.3)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(0, 255, 198, 0.05)'
                                }]
                            }
                        }
                    }],
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(0, 28, 53, 0.9)',
                        borderColor: 'rgba(5, 133, 247, 0.5)',
                        textStyle: {
                            color: '#9ED1FF'
                        }
                    }
                };
                
                chart.setOption(option);
                this.chartInstance = chart;
                
                // 响应式调整
                window.addEventListener('resize', this.handleChartResize);
            });
        },
        handleChartResize() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        },
        disposeChart() {
            if (this.chartInstance) {
                this.chartInstance.dispose();
                this.chartInstance = null;
            }
            window.removeEventListener('resize', this.handleChartResize);
        },
        customizeTableScrollbars() {
            // 等待DOM更新
            this.$nextTick(() => {
                const tableWrapper = this.$el.querySelector('.evidence-table-container .el-table__body-wrapper');
                if (tableWrapper) {
                    // 创建样式标签
                    const styleId = 'custom-table-scrollbar';
                    if (!document.getElementById(styleId)) {
                        const style = document.createElement('style');
                        style.id = styleId;
                        style.textContent = `
                            /* 强制覆盖所有el-table滚动条样式 - 只显示Y轴滚动条 */
                            .evidence-table-container .el-table__body-wrapper {
                                overflow-y: auto !important;
                                overflow-x: hidden !important;
                                scrollbar-width: thin !important;
                                scrollbar-color: rgba(5, 133, 247, 0.8) rgba(0, 28, 53, 0.1) !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar {
                                width: 2px !important;
                                height: 0 !important; /* 隐藏X轴滚动条 */
                                background: transparent !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar:horizontal {
                                display: none !important; /* 完全隐藏水平滚动条 */
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-track {
                                background: rgba(0, 28, 53, 0.1) !important;
                                border-radius: 1px !important;
                                border: none !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb {
                                background: rgba(5, 133, 247, 0.8) !important;
                                border-radius: 1px !important;
                                border: none !important;
                                min-height: 20px !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
                                background: rgba(5, 133, 247, 1) !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-corner {
                                background: transparent !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-button {
                                display: none !important;
                            }
                        `;
                        document.head.appendChild(style);
                    }
                    
                    // 强制重绘滚动条
                    tableWrapper.style.overflowY = 'auto';
                    tableWrapper.style.overflowX = 'hidden';
                    tableWrapper.style.scrollbarWidth = 'thin';
                    tableWrapper.style.scrollbarColor = 'rgba(5, 133, 247, 0.8) rgba(0, 28, 53, 0.1)';
                    
                    // 重新触发滚动条渲染
                    const scrollTop = tableWrapper.scrollTop;
                    tableWrapper.scrollTop = scrollTop + 1;
                    tableWrapper.scrollTop = scrollTop;
                    
                    // 强制添加类名
                    tableWrapper.classList.add('custom-scrollbar');
                }
            });
        }
    },
    beforeDestroy() {
        this.disposeChart();
    }
}
</script>

<style scoped lang="less">
/* 弹窗样式 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-content {
    background: rgba(0, 74, 140, 0.2);
    border: 1px solid rgba(5, 133, 247, 0.5);
    border-radius: 8px;
    width: 1338px;
    height: 892px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 0 20px;
    // background: linear-gradient(90deg, rgba(0, 145, 235, 0.64) 0%, rgba(0, 37, 74, 0) 100%);
    background: url(../../../assets/image/modal-header.png) no-repeat center center;
}

.modal-title {
    color: #fff;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
}

.modal-close {
    background: url(../../../assets/image/modal-close.png) no-repeat center center;
    background-size: contain;
    border: none;
    cursor: pointer;
    padding: 0;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.modal-close:hover {
    opacity: 0.8;
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
}

.modal-card {
    background: rgba(0, 74, 140, 0.3);
}

.modal-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.modal-row:first-child {
    height: 582px;
}

.chart-row {
    width: 100%;
    height: 210px;
    background: rgba(0, 74, 140, 0.3);
    padding: 20px;
}

.chart-section {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chart-content {
    flex: 1;
    width: 100%;
}

.modal-left {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.modal-right {
    flex: 2;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.video-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.modal-video {
    width: 100%;
    height: 200px;
    background: #000;
    border-radius: 4px;
    border: 1px solid rgba(5, 133, 247, 0.3);
}

/* 统一的标题样式 */
.section-title {
    position: relative;
    padding-left: 20px;
    margin: 0 0 15px 0;
    color: #9ED1FF;
    font-size: 16px;
    font-weight: 500;
}

.section-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    background: url(../../../assets/image/modal-indicator.png) no-repeat center center;
    background-size: contain;
}

.problem-description {
    background: rgba(0, 28, 53, 0.5);
    padding: 15px;
    border-radius: 4px;
    border: 1px solid rgba(5, 133, 247, 0.2);
    flex: 1;
    overflow-y: auto;
    margin-top: 20px;
}

.problem-description .problem-title {
    margin-bottom: 10px;
}

.problem-description p {
    color: #FFFFFF;
    margin: 0;
    line-height: 1.5;
    font-size: 16px;
    line-height: 30px;
}

.evidence-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 0;
}

.evidence-section .evidence-title {
    margin-bottom: 15px;
}

.evidence-table-container {
        flex: 1;
        overflow: hidden;
        border: 1px solid rgba(5, 133, 247, 0.3);
        border-radius: 4px;
        background: rgba(0, 28, 53, 0.3);
        min-height: 0;
        /* 强制自定义滚动条 - 只显示Y轴滚动条 */
        --scrollbar-width: 2px;
        --scrollbar-height: 0; /* 隐藏X轴滚动条 */
        --scrollbar-track-bg: rgba(0, 28, 53, 0.1);
        --scrollbar-thumb-bg: rgba(5, 133, 247, 0.8);
        --scrollbar-thumb-hover-bg: rgba(5, 133, 247, 1);
    }

/* 自定义弹窗滚动条 */
.modal-body::-webkit-scrollbar {
    width: 6px;
}

.modal-body::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1);
    border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.5);
    border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 0.8);
}

/* el-table滚动条强制自定义样式 */
.evidence-table-container *::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container *::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1) !important;
    border-radius: 1px !important;
}

.evidence-table-container *::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
    border: none !important;
}

.evidence-table-container *::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 1) !important;
}

/* 强制隐藏系统默认滚动条 */
.evidence-table-container .el-table__body-wrapper,
.evidence-table-container .el-table__fixed-body-wrapper,
.evidence-table-container .el-table__fixed-right-body-wrapper {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
}

.evidence-table-container .el-table__body-wrapper::-webkit-scrollbar,
.evidence-table-container .el-table__fixed-body-wrapper::-webkit-scrollbar,
.evidence-table-container .el-table__fixed-right-body-wrapper::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

/* 深度作用域选择器确保样式生效 */
.evidence-table-container /deep/ .el-table__body-wrapper::-webkit-scrollbar,
.evidence-table-container /deep/ .el-table__fixed-body-wrapper::-webkit-scrollbar,
.evidence-table-container /deep/ .el-table__fixed-right-body-wrapper::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb,
.evidence-table-container /deep/ .el-table__fixed-body-wrapper::-webkit-scrollbar-thumb,
.evidence-table-container /deep/ .el-table__fixed-right-body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
}

/* Vue3的:deep()选择器 */
.evidence-table-container :deep(.el-table__body-wrapper::-webkit-scrollbar) {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container :deep(.el-table__body-wrapper::-webkit-scrollbar-thumb) {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
}

</style>

<style scoped lang="less">
/* 使用::v-deep强制覆盖Element UI样式 - 只显示Y轴滚动条 */
::v-deep .evidence-table-container .el-table__body-wrapper {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scrollbar-width: thin !important;
    scrollbar-color: rgba(5, 133, 247, 0.8) rgba(0, 28, 53, 0.1) !important;
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar {
    width: 2px !important;
    height: 0 !important; /* 隐藏X轴滚动条 */
    background: transparent !important;
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar:horizontal {
    display: none !important; /* 完全隐藏水平滚动条 */
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1) !important;
    border-radius: 1px !important;
    border: none !important;
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
    border: none !important;
    min-height: 20px !important;
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 1) !important;
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-corner {
    background: transparent !important;
}

::v-deep .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-button {
    display: none !important;
}
</style>

<style lang="less">
/* 全局强制样式 - 放在scoped外部 */
.evidence-table-container .el-table__body-wrapper {
    overflow: auto !important;
}

.evidence-table-container .el-table__body-wrapper::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1) !important;
    border-radius: 1px !important;
}

.evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
}

.evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 1) !important;
}
</style>